
// import Vue from 'vue'
import textHelper from './textManager'
import {scroller} from 'vue-scrollto/src/scrollTo'
const moment = require("moment");
const search = require('binary-search')
var {nanoid} = require('nanoid')
require('moment-duration-format')
//const findAllIndexes = require('find-all-indexes').default;
//const replaceall = require("replaceall");
let phraseScroller = null;
// let phraseScrollerReadOnly = null;

export default {
  getWordIndexByIndex (words, newIndex) {
    if (newIndex === 0) {
      return 0
    }

    return search(words, newIndex, function (element, needle) {
      if ((element.start < needle && element.end > needle) || needle === (element.end + 1)) {
        return 0
      }
      if (element.start >= needle) {
        return 1
      }
      if (element.end < needle) {
        return -1
      }
    })
  },
  getWordIndexByIndexFromTo (words, newIndex, isFrom) {
    

    if(!isFrom){
      newIndex--;
    }

    if (newIndex < 0) {
      return 0
    }

    return search(words, newIndex, function (element, needle) {
      if ((element.start <= needle && element.end >= needle)) {
        return 0
      }
      if (element.start > needle) {
        return 1
      }
      if (element.end < needle) {
        return -1
      }
    })
  },
  getPreWord(words, wordIndex){
    let preWordIndex = 0;
    if(wordIndex > 0 ){
      preWordIndex = wordIndex - 1;
    }
    else{
      return {startTime: words[preWordIndex].startTime - 0.01, endTime: words[preWordIndex].startTime - 0.01};
    }

    return words[preWordIndex]
  },
  getNextWord(words, wordIndex){
    let nextWordIndex = words.length -1;
    if(wordIndex < nextWordIndex ){
      nextWordIndex = wordIndex + 1;
    }
    else{
      // end word is edge case
      return {startTime: words[nextWordIndex].endTime + 0.01, endTime: words[nextWordIndex].endTime + 0.01};
    }

    return words[nextWordIndex];
  },
  getWordIndexByTime (words, newTime) {
    return search(words, newTime, function (element, needle) {
      if (element.startTime <= needle && element.endTime >= needle) {
        return 0
      }
      if (element.startTime > needle) {
        return 1
      }
      if (element.endTime < needle) {
        return -1
      }
    })
  },
  getPhraseIndexByTime (phrases, newTime) {
    return search(phrases, newTime, function (element, needle) {
      if (element.startTime <= needle && element.endTime >= needle) {
        return 0
      }
      if (element.startTime > needle) {
        return 1
      }
      if (element.endTime < needle) {
        return -1
      }
    })
  },
  getClosest(elem, selector, cloneNode){
    let elem2 = cloneNode ? elem.cloneNode(true) : elem;

    // // when the type is div and the class name is the container itself and has empty content
    // if(elem.nodeType === 1 && ('.'+ elem.className) === selector && !elem.innerHTML ){
    //   console.log('Phrase content: Needs attention')
    //   throw 'transcriptHelper -> getClosest -> ' + elem.nodeType +' '+ elem.className;
    // }
    // else if(elem.nodeType === 1){
    //   elem2 = elem2.querySelector(selector);
    // }

    if(elem.nodeType === 1){
      elem2 = elem2.querySelector(selector);
    }

    if(!elem2 || elem.nodeType !== 1){
      elem2 = elem.parentElement.closest(selector);
    }

    if(!elem2){
      return null;
    }

    return elem2;
  },
  getSelectionInfo (storePhrases) {
//    try{
      if(!document.selection && !window.getSelection().anchorNode){
        return null;
      }

      let content1 = document.selection ? this.getClosest(document.selection.createRange(), '.phrase-content') : this.getClosest(window.getSelection().anchorNode, '.phrase-content', true)
      let content2 = document.selection ? this.getClosest(document.selection.createRange(), '.phrase-content') : this.getClosest(window.getSelection().focusNode, '.phrase-content', true)

      if(!content1 || !content2 || content1.classList.contains('user-select-none') || content2.classList.contains('user-select-none')){
        content1 = document.selection ? this.getClosest(document.selection.createRange(), '.phrase-content-container') : this.getClosest(window.getSelection().anchorNode, '.phrase-content-container', true)
        content2 = document.selection ? this.getClosest(document.selection.createRange(), '.phrase-content-container') : this.getClosest(window.getSelection().focusNode, '.phrase-content-container', true)
        if(!content1 || !content2 || content1.classList.contains('user-select-none') || content2.classList.contains('user-select-none')){
          return null;
        }
      }

      const positionAttributeName = content1.className === 'phrase-content-container' ? 'data-container-position': 'data-position';
      let phraseIndex1 = storePhrases.findIndex(item => item.id === content1.getAttribute(positionAttributeName));
      let phraseIndex2 = storePhrases.findIndex(item => item.id === content2.getAttribute(positionAttributeName));

      let caretPosition1 = null
      let caretPosition2 = null

      if (phraseIndex1 > phraseIndex2) {
        caretPosition1 = textHelper.getCaretCharacterOffsetWithinEnd(content1)
        caretPosition2 = textHelper.getCaretCharacterOffsetWithinStart(content2)

        return { phraseStartIndex: phraseIndex2, phraseEndIndex: phraseIndex1, charStartIndex: caretPosition2, charEndIndex: caretPosition1, contentStart: content2, contentEnd: content1 }
      } else {
        caretPosition1 = textHelper.getCaretCharacterOffsetWithinStart(content1)
        caretPosition2 = textHelper.getCaretCharacterOffsetWithinEnd(content2)
        return { phraseStartIndex: phraseIndex1, phraseEndIndex: phraseIndex2, charStartIndex: caretPosition1, charEndIndex: caretPosition2, contentStart: content1, contentEnd: content2 }
      }
      
  //  }
    // catch(err){
    //   if(err.nodeType!==1){
    //     console.log('nodeType: '+ err.nodeType+err.data+'----'+err.parentElement.outerHTML);
    //   }
    //   else if(err.nodeType===1){
    //     console.log('nodeType 1:'+ err.outerHTML);
    //   }
    //   else{
    //     console.log(err);
    //   }
      
    //   return null;
    // }
  },
  getSortedPhrases (transcript) {
    let phrases = []

    if (!transcript) {
      return []
    }

    if (!Array.isArray(transcript)) {
      let keys = Object.keys(transcript)

      keys.forEach(function (key) {
        let phrase = transcript[key]
        if (phrase) {
          phrases.push(phrase)
        }
      })
    } else {
      phrases = transcript
    }

    phrases.sort(function (a, b) {
      if (a.startTime === b.startTime && a.order && b.order) {
        return a.order - b.order
      }
      return a.startTime - b.startTime
    })

    let count = 0.1
    phrases.forEach(function (phrase) {
      if (!phrase.order) {
        phrase.order = count
        count = count + 1
      } 
    })

    return phrases
  },
  clearHighlight(){
    if (window.$activeWord) {
      document
        .getElementsByTagName('head')[0]
        .removeChild(window.$activeWord)
      window.$activeWord = null
    }
  },
  highlightWordByPosition (phraseIndex, wordIndex, phrases) {
    const me = this
    if(phraseIndex >= 0 && wordIndex >= 0){
      me.updateHighlights(phraseIndex, wordIndex, phrases)
    }
  },
  highlightWordByTime (timestamp, phrases, extraBold, readOnly) {
    const me = this
    let words = []
    let newTime = timestamp
    let wordIndex = -1

    // Find the phrase index
    let phraseIndex = me.getPhraseIndexByTime(
      phrases,
      newTime
    )

    // Find the word index
    if (phraseIndex > -1) {
      words = phrases[phraseIndex].words
      wordIndex = me.getWordIndexByTime(words, newTime)
    }

    if(phraseIndex >= 0 && wordIndex >= 0){
      me.updateHighlights(phraseIndex, wordIndex, phrases, extraBold, readOnly)
    }
  },
  clearAllHighlights(){
    let allWordElements = document.querySelectorAll(`span[data-position]`);
    allWordElements.forEach(el => {
      el.style ='';
    })
  },
  getElement(phraseIndex, wordIndex, phrases, readOnly){
    if(wordIndex < 0){
      phraseIndex--;
      if(phraseIndex < 0){
        return null;
      }
      wordIndex = phrases[phraseIndex].words.length - 1;
    }
    else if(wordIndex >= phrases[phraseIndex].words.length){
      phraseIndex++;
      if(phraseIndex >= phrases.length){
        return null;
      }
      wordIndex = 0;
    }

    const phraseContentDom = readOnly ? document.querySelector(`[contenteditable="false"][data-position="${phrases[phraseIndex].id}"]`) : document.querySelector(`[contenteditable="plaintext-only"][data-position="${phrases[phraseIndex].id}"]`);

    return phraseContentDom && phraseContentDom.querySelector(`span[data-position="${phraseIndex}:${wordIndex}"]`);
  },


  getTimeFormat(duration, milliSeconds, unit, type){
    if(type === 'standard'){
      return moment.duration(milliSeconds, unit).format('hh:mm:ss', { trim: false })
    }
    
    if (duration >= 3600) {
      return moment.duration(milliSeconds, unit).format('h:mm:ss.SS', { trim: false })
    } else if (duration >= 60) {
      return moment.duration(milliSeconds, unit).format('mm:ss.SS', { trim: false })
    } else {
      return moment.duration(milliSeconds, unit).format('m:ss.SS', { trim: false })
    }
  },

  updateHighlights(phraseIndex, wordIndex, phrases, extraBold, readOnly) {
    const me = this;
    const isDark = window.localStorage.getItem('darkMode') === 'true'
    if(me.el){
      me.el.style.color =  isDark ? "white" :"#06150e";
      me.el.style.borderRadius = "0px";
      me.el.style.backgroundColor = "transparent";
    }

    me.el = me.getElement(phraseIndex, wordIndex, phrases, readOnly);
    

    if(me.el){
      if(extraBold){
        me.el.style.color = "#e2f8f2";
        me.el.style.borderRadius = "3px";
        me.el.style.backgroundColor = "#1fa363";
    }
    else{
      
        me.el.style.color = isDark ? "#20F7C4":"#1fa363";
        me.el.style.borderRadius = "3px";
        me.el.style.backgroundColor = "tranparent";
      }
    }
  },
  isMultilineSelection (selectionInfo) {
    return selectionInfo.phraseStartIndex !== selectionInfo.phraseEndIndex
  },
  isMultiCharSelection (selectionInfo) {
    return selectionInfo.charStartIndex !== selectionInfo.charEndIndex && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex
  },
  isFirstLineSpecialCase(storePhrases, selectionInfo){
    return selectionInfo.phraseStartIndex < 1 && storePhrases.length > 1 &&
    (storePhrases[0].transcript.length === selectionInfo.charEndIndex -selectionInfo.charStartIndex || 
     storePhrases[0].transcript === ' '||
     selectionInfo.charEndIndex === 1 && selectionInfo.charStartIndex === 1 && selectionInfo.phraseEndIndex < 1 && storePhrases[0].transcript.length === 1);

  },
  isLastLineSpecialCase(storePhrases, selectionInfo){
    return selectionInfo.phraseStartIndex === storePhrases.length - 1 && storePhrases.length > 1 &&
    (storePhrases[storePhrases.length - 1].transcript.length === selectionInfo.charEndIndex || 
     storePhrases[storePhrases.length - 1].transcript === ' ');

  },
  getMergeOnBackSpaceSetup (event, storePhrases, selectionInfo) {
    const keyCode = event.keyCode || event.which
    if (selectionInfo.phraseStartIndex < 1) {
      if(this.isFirstLineSpecialCase(storePhrases, selectionInfo)){
        selectionInfo.phraseStartIndex = 0;
        selectionInfo.phraseEndIndex = 1;
        selectionInfo.charStartIndex = 0;
        selectionInfo.charEndIndex = 0;

        return selectionInfo
      }
    }

    if (( (keyCode === 8 || event.type === "cut" )&& storePhrases[selectionInfo.phraseStartIndex].transcript.length === 1 && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex) || //  1 char in length
    ((keyCode === 8 || event.type === "cut" ) && selectionInfo.charStartIndex === 0 && selectionInfo.charEndIndex === 0 && selectionInfo.phraseStartIndex !== 0)|| //  1 char in length
    ((keyCode === 8 || event.type === "cut" ) && selectionInfo.charStartIndex === 0 && selectionInfo.charEndIndex === storePhrases[selectionInfo.phraseStartIndex].transcript.length && selectionInfo.phraseStartIndex !== 0)) {
      selectionInfo.phraseStartIndex = selectionInfo.phraseStartIndex - 1
      selectionInfo.charStartIndex = storePhrases[selectionInfo.phraseStartIndex].transcript.length
    }//vanille backspace with no selection case
    else if(keyCode === 8 && selectionInfo.charStartIndex === selectionInfo.charEndIndex && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex){
      selectionInfo.charStartIndex = selectionInfo.charStartIndex -1;
    }

    // special case to remove line when phrase index is same means no selection
    // if (( (keyCode === 8 || event.type === "cut" )&& storePhrases[selectionInfo.phraseStartIndex].transcript.length === 1 && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex) || //  1 char in length
    //     ((keyCode === 8 || event.type === "cut" ) && selectionInfo.charStartIndex === 0 && selectionInfo.phraseStartIndex !== 0)) {
    //   selectionInfo.phraseStartIndex = selectionInfo.phraseStartIndex - 1
    //   selectionInfo.charStartIndex = storePhrases[selectionInfo.phraseStartIndex].transcript.length
    // }//vanille backspace with no selection case
    // else if(keyCode === 8 && selectionInfo.charStartIndex === selectionInfo.charEndIndex && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex){
    //   selectionInfo.charStartIndex = selectionInfo.charStartIndex -1;
    // }

    return selectionInfo
  },
  getMergeOnDeleteSetup (event, storePhrases, selectionInfo) {
    const keyCode = event.keyCode || event.which
    if (selectionInfo.phraseStartIndex === storePhrases.length -1) {
      if(this.isLastLineSpecialCase(storePhrases, selectionInfo)){
        // selectionInfo.phraseStartIndex = 0;
        // selectionInfo.phraseEndIndex = 1;
        // selectionInfo.charStartIndex = 0;
        // selectionInfo.charEndIndex = 0;

        // selectionInfo.phraseStartIndex--;
        // selectionInfo.charStartIndex = storePhrases[selectionInfo.phraseStartIndex].transcript.length;

        return selectionInfo
      }
    }

    // special case to remove line when phrase index is same means no selection
    if (( (keyCode === 46 )&& storePhrases[selectionInfo.phraseStartIndex].transcript.length === 1 && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex) || //  1 char in length
    ((keyCode === 46 ) && selectionInfo.charEndIndex === selectionInfo.charStartIndex && selectionInfo.charEndIndex === storePhrases[selectionInfo.phraseStartIndex].transcript.length && selectionInfo.phraseStartIndex !== storePhrases.length -1) ||
    ((keyCode === 46 ) && selectionInfo.charStartIndex === 0 && selectionInfo.charEndIndex === storePhrases[selectionInfo.phraseStartIndex].transcript.length && selectionInfo.phraseStartIndex !== storePhrases.length -1)) {
      selectionInfo.phraseEndIndex = selectionInfo.phraseEndIndex + 1
      selectionInfo.charEndIndex = 0
    }//vanille backspace with no selection case
    else if(keyCode === 46 && selectionInfo.charStartIndex === selectionInfo.charEndIndex && selectionInfo.phraseStartIndex === selectionInfo.phraseEndIndex){
      selectionInfo.charEndIndex = selectionInfo.charEndIndex +1;
    }

    return selectionInfo
  },
  mergePhrase (phrase1, phrase2) {
   // let endChar = phrase1.words[phrase1.words.length - 1].end
    // phrase 2 will be empty if backspace last character on a line.
   // let startChar = phrase2.words.length ? phrase2.words[0].start : 0
    //let offSet = endChar + 1 - startChar
    let clonePhrase2 = JSON.parse(JSON.stringify(phrase2))
    //let phraseMergeIndex = phrase1.words.length - 1

    // merge if the latter merge phrase has length of 1 or 0. (should only occurs for new line)
    if (!(clonePhrase2.words.length === 1 && clonePhrase2.words[0].word === ' ')) {
      
      phrase1.words.push(JSON.parse(JSON.stringify(phrase2.words[0])))
      clonePhrase2.words.shift()
      phrase1.words = (phrase1.words.concat(clonePhrase2.words))
    }

    this.updateWordStartEnd(phrase1.words)

    phrase1.endTime = phrase2.endTime
    phrase1.transcript = this.toTranscript(phrase1.words)

    return phrase1
  },

  mergeWord (config) {
    const phrase = config.phrase
    const index = config.index
    const newOffset = config.newOffset
    const inputData = config.inputData

    let words = phrase.words
    let newIndex = index + newOffset
    let wordCutoffIndex = this.getWordIndexByIndex(words, newIndex)
    let wordIndex = this.getWordIndexByIndex(words, index)
    let originalWords = JSON.parse(JSON.stringify(words))
    let originalWord = originalWords[wordIndex]

    // remove the selection word in the current word token
    this.removeCharsInWord(phrase, wordIndex, index, newOffset,inputData)

    // if the selection exceeds the current token
    if (originalWord.end - index < newOffset) {
      if (wordCutoffIndex !== wordIndex) {
        if (wordCutoffIndex > -1) {
          var cutoffWord = originalWords[wordCutoffIndex] // words[wordCutoffIndex];

          // merge
          cutoffWord.word = cutoffWord.word.slice(newIndex - cutoffWord.start)

          words[wordIndex].word += cutoffWord.word
          words[wordIndex].endTime = words[wordCutoffIndex].endTime
          words[wordIndex].end += cutoffWord.word.length
        }

        words.splice(wordIndex + 1, Math.abs(wordCutoffIndex - wordIndex))
        this.updateWordStartEnd(words)
      }
    }
    // removing word to start of token should merge the previous
    if (originalWord.start === index && wordIndex > 0) {
      words[wordIndex - 1].word += words[wordIndex].word
      words[wordIndex - 1].endTime = words[wordIndex].endTime
      words[wordIndex - 1].end += words[wordIndex].word.length
      words.splice(wordIndex, 1)
      this.updateWordStartEnd(words)
    }

    phrase.transcript = this.toTranscript(words)
    return words
  },

  updateWordStartEnd (words) {
    var count = 0
    // And your a tester
    for (var j = 0; j < words.length; j++) {
      words[j].start = count
      words[j].end = (count + words[j].word.length - 1)
      count = words[j].end + 1
    }
  },
  updateStorePhrasesSplit (storePhrases, selectionInfo) {
    let clonePhrase = storePhrases[selectionInfo.phraseStartIndex]
   // let nextPhrase = storePhrases[selectionInfo.phraseStartIndex + 1];
    const originalPhrase = JSON.parse(JSON.stringify(storePhrases[selectionInfo.phraseStartIndex]));
    let newPhrase = this.splitPhraseReverse(
      clonePhrase,
      selectionInfo.charStartIndex,
      selectionInfo.phraseStartIndex <= 0 ? null : storePhrases[selectionInfo.phraseStartIndex - 1],
      selectionInfo.phraseStartIndex
    )
    function finding_index (element) {
      return element.id === clonePhrase.id
    }

    // Hack fix revisit after test complete
    if (newPhrase.words.length === 1 && newPhrase.words[0].word === '') {
      newPhrase.words[0].word = ' '
      newPhrase.words[0].start = 0
      newPhrase.words[0].end = 0
      newPhrase.transcript = ' '
    }

    if (clonePhrase.words.length === 1 && clonePhrase.words[0].word === '') {
      clonePhrase.words[0].word = ' '
      clonePhrase.words[0].start = 0
      clonePhrase.words[0].end = 0
      clonePhrase.transcript = ' '
    }

    let index = storePhrases.findIndex(finding_index)
    storePhrases.splice(index, 1, newPhrase, clonePhrase)

    // update any duplicate time , add 1 because clonePhrase had a newPhrase inserted after
    const updatedPhrases = this.updatePhraseTimeConflict(clonePhrase, newPhrase, storePhrases, selectionInfo.phraseStartIndex+1);

    let results = [clonePhrase, newPhrase];

    if(updatedPhrases && updatedPhrases.length){
      results = results.concat(updatedPhrases);
    }

    let cloneNewPhrase = JSON.parse(JSON.stringify(newPhrase));
    cloneNewPhrase.words = null;
    cloneNewPhrase.transcript = '';


    let originalResults = [cloneNewPhrase, originalPhrase ];
    
    return {modifiedPhrases:results, originalPhrases: originalResults};
  },
  updateTime(phrase, startTime, endTime){

    const roundTime = (time) => Math.round(time * 100) / 100;

    if(startTime || endTime){
      phrase.startTime = startTime || phrase.startTime;
      phrase.endTime = endTime || phrase.endTime;
  
      phrase.startTime = roundTime(phrase.startTime);
      phrase.endTime = roundTime(phrase.endTime);
  
      if (Array.isArray(phrase.words) && phrase.words.length > 0){
        phrase.words[0].startTime = phrase.startTime;
        phrase.words[phrase.words.length-1].endTime = phrase.endTime;
      }
    }
    else{
      if(phrase.words && phrase.words.length){
        const tempStart = roundTime(phrase.words[0].startTime);
        const tempEnd = roundTime( phrase.words[phrase.words.length-1].endTime);
        phrase.words[0].startTime = tempStart;
        phrase.words[phrase.words.length-1].endTime = tempEnd;
        phrase.startTime = tempStart;
        phrase.endTime = tempEnd;
      }
    }


  },

  updatePhraseTimeConflict(phrase2, phrase1, phrases, startIndex) {
    const me = this;
    const minGap = 0.01;
    const minDuration = 0.3;
    let stop = startIndex;
    const updatedPhrases = [];

    function ensureMinDuration(phrase) {
      if (phrase.endTime - phrase.startTime < minDuration) {
        me.updateTime(phrase, null, phrase.startTime + minDuration);
      }
    }
  
    ensureMinDuration(phrase1);

    // Ensure phrase1 doesn't overlap with phrase2
    if (phrase1.endTime >= phrase2.startTime) {
      me.updateTime(phrase2, phrase1.endTime + minGap, null);
      ensureMinDuration(phrase2);
    }
  
  
    // Propagate changes through the rest of the phrases
    for (let i = startIndex; phrases && i < phrases.length - 1; i++) {
      let currentPhrase = phrases[i];
      let nextPhrase = phrases[i + 1];
  
     // ensureMinDuration(currentPhrase);
  
      if (currentPhrase.endTime >= nextPhrase.startTime) {
        me.updateTime(nextPhrase, currentPhrase.endTime + minGap, null);
        ensureMinDuration(nextPhrase);
        updatedPhrases.push(nextPhrase);
        stop = i;
      } else {
        // If there's no overlap, we can stop propagating changes
        break;
      }
    }
  
    // Final rounding for all affected phrases
    me.updateTime(phrase1, phrase1.startTime, phrase1.endTime);
    for (let i = startIndex; i < stop; i++) {
      me.updateTime(phrases[i], phrases[i].startTime, phrases[i].endTime);
    }
  
    return updatedPhrases;
    //return phrases;
  },
  updatePhraseTimeConflict2(phrase2, phrase1, phrase3) {
    const me = this;
   // const roundTime = (time) => Math.round(time * 100) / 100;
    const minGap = 0.01;
    const minDuration = 0.3;
  
    function ensureMinDuration(phrase) {
      if (phrase.startTime >= phrase.endTime) {
        me.updateTime(phrase, null, phrase.startTime + minDuration);
      }
    }
  
    // Initial rounding
    [phrase1, phrase2, phrase3].forEach(p => p && me.updateTime(p, p.startTime, p.endTime));
  
    // Ensure minimum duration for each phrase
    ensureMinDuration(phrase1);
    ensureMinDuration(phrase2);
    if (phrase3) ensureMinDuration(phrase3);
  
    // Resolve conflicts
    if (phrase1.endTime >= phrase2.startTime) {
      me.updateTime(phrase2, phrase1.endTime + minGap, null);
      ensureMinDuration(phrase2);
    }
  
    if (phrase3 && phrase2.endTime >= phrase3.startTime) {
      me.updateTime(phrase3, phrase2.endTime + minGap, null);
      ensureMinDuration(phrase3);
    }
  
    // Final rounding
    [phrase1, phrase2, phrase3].forEach(p => p && me.updateTime(p, p.startTime, p.endTime));
  
    return { phrase1, phrase2, phrase3 };
  },
  updatePaginatedPhrasesWithDictionary(paginatedPhrases,dictionaryArray){
    const me = this;
    let oriResults = [];
    let modiResults = [];
    paginatedPhrases.forEach(function(phrases){
      let {originalPhrases, modifiedPhrases} = me.updatePhrasesWithDictionary(phrases, dictionaryArray)
      oriResults = oriResults.concat(originalPhrases);
      modiResults = modiResults.concat(modifiedPhrases); 
    })

    return {originalPhrases:oriResults, modifiedPhrases:modiResults}; 
  },
//   updatePhrasesWithDictionary(phrases, dictionaryArray){
//     const me = this;
//     let flatText = phrases.map(function(phrase){return phrase.transcript}).join('-');
//     let filteredDicionaryArray = [];
//     let filteredOriginal = [];
//     let startIndexes = [];
//     let maxOriginalLength = 0;
//     let modifiedPhrases = [];
//     let originalPhrases = [];

//       dictionaryArray.forEach(function(p){
//         if(flatText.indexOf(p[0]) > -1){
//           filteredDicionaryArray.push(p);
//         }
//       })

//       if (!dictionaryArray.length || !filteredDicionaryArray.length) {
//         return {originalPhrases, modifiedPhrases};
//       }
      
//       filteredOriginal = filteredDicionaryArray.map(function(arr){return arr[0]});

//       for(var i = 0 ; i < phrases.length; i++){
//         let phrase = phrases[i];
//         let tempTranscript = phrase.transcript;
//         maxOriginalLength = 0;
//         startIndexes = findAllIndexes(tempTranscript, filteredOriginal)

//         startIndexes.sort(function (a, b) {
//             return a - b;
//         });

//         filteredDicionaryArray.forEach(function(replacements){
//           const original = replacements[0];
//           const updated = replacements[1];
//           let temp = replaceall(original,updated, tempTranscript);

//           if(temp!==tempTranscript){
//             maxOriginalLength = Math.max(original.length,maxOriginalLength);
//           }

//           tempTranscript = temp;
//         })

//         if(tempTranscript !== phrase.transcript){
//           originalPhrases.push(JSON.parse(JSON.stringify(phrase)))
//           phrases[i].transcript = tempTranscript;
//           phrases[i].words = me.updatePhraseWords(phrases[i], startIndexes, maxOriginalLength, filteredDicionaryArray);
//           phrases[i].modified = moment.utc().format();
//           modifiedPhrases.push(JSON.parse(JSON.stringify(phrases[i])));
//         }
//       }

//      // return modifiedPhrases
//       return {originalPhrases, modifiedPhrases};
//   },

//   updatePhraseWords(phrase, startIndexes, length, dictionaryArray) {
//     let clonePhrase = JSON.parse(JSON.stringify(phrase));
//     let words = clonePhrase.words;
//     let mapping = [];
    
//     // build mapping overal index to word index
//     for(var i = 0 ; i < words.length; i++)
//     {
//       for(var j = 0 ; j < words[i].word.length; j++){
//         mapping.push(i);
//       }
//     }

//    let index = 0;
//    let newWords = [];
//    let wordIndex = 0;
//    let offset = 0;

//    while(wordIndex < words.length){
//     if(wordIndex === mapping[startIndexes[index]]){
//       let tempWords = JSON.parse(JSON.stringify(words[wordIndex]));
//       for(var k = wordIndex + 1; k <= mapping[startIndexes[index]+length-1]; k++ ){
//         tempWords.word += words[k].word;
//         tempWords.endTime = words[k].endTime;
//         wordIndex = k;
//       }
      
//       // replace all in dictionary
//       let replaceWord = tempWords.word;
//       dictionaryArray.forEach(function(replacements){
//         const original = replacements[0];
//         const updated = replacements[1];
//         const tempReplaceWord = replaceall(original,updated, replaceWord);
//         if(replaceWord !== tempReplaceWord){
//           replaceWord = tempReplaceWord;
//           tempWords.word = replaceWord;
//           index++;
//         }
//       })

//       newWords.push(tempWords);
//     }
//     else{
//       newWords.push(words[wordIndex]);
//     }

//     newWords[newWords.length-1].start = offset;
//     newWords[newWords.length-1].end = offset + newWords[newWords.length-1].word.length - 1;
//     offset = offset + newWords[newWords.length-1].word.length;

//     wordIndex++;
//    }

//    return newWords;
//   },
  insertCharsInWord (words, wordIndex, insertStartingPosition, insertContent) {
    var word = words[wordIndex]
    insertContent = insertContent || '';
    if (word) {
      words[wordIndex].word = word.word.slice(0, insertStartingPosition - word.start) + insertContent + word.word.slice(insertStartingPosition - word.start)
      words[wordIndex].end += insertContent.length

      this.updateWordStartEnd(words)
    }
  },

  removeCharsInWord (phrase, wordIndex, removeStartingPosition, removeWordLength, insertContent) {
    let words = phrase.words
    let word = words[wordIndex]
    let percentage = 1;
    insertContent = insertContent || '';

    if (word) {
      const frontPortionWord = word.word.slice(0, removeStartingPosition - word.start)+ insertContent + word.word.slice(removeStartingPosition - word.start + removeWordLength);
      percentage = frontPortionWord.length / words[wordIndex].word.length;
      words[wordIndex].word = frontPortionWord;
      words[wordIndex].end = Math.max(removeStartingPosition - 1, words[wordIndex].end - removeWordLength)
      words[0].startTime = phrase.startTime;
      this.updateWordStartEnd(words)
    }

    return percentage;
  },
  removeEmptyWords (phrase) {
    const words = phrase.words;
    function finding_index (element) {
      return element.word === ''
    }
    let index = words.findIndex(finding_index)

    if (index > -1) {
      words.splice(index, 1);

      // sync the phrase start end time word word after a blank removal
      if(words && words.length){
        this.updateTime(phrase);
      }
    }
  },
//   setCaretByPhraseIndex(phraseIndex, charIndex){
//     const div = document.getElementsByClassName("phrase-content") ? document.getElementsByClassName("phrase-content")[phraseIndex] : null;
//     const span = div ? div.getElementsByTagName("span")[0] : null;

//     if(span){
//         textHelper.setCaretPosition(span, charIndex);
//     }
//   },
//   setCaretByPhraseId(phraseId,charIndex){
//     const phraseDom = document.querySelector('#'+phraseId);

//     if(phraseDom){
//       textHelper.setCaretPosition(
//         phraseDom.querySelector(".phrase-content"),
//         charIndex
//       );
//     }
//   },
  splitPhraseReverse (phrase, charIndex, previousPhrase, phraseIndex) {
    let clone = JSON.parse(JSON.stringify(phrase));
    let wordIndex = this.getWordIndexByIndex(
      phrase.words,
      charIndex
    );
    let phraseWord = phrase.words[wordIndex];
    let cloneWord = clone.words[wordIndex];
    
    phrase.note ='';
    phraseIndex = phraseIndex||0;
    // create new id for the clone phrase
    clone.id = 'p-' + phraseIndex + nanoid(5)

    // create new id for all words in clone
    clone.words.forEach(function (word, index) {
      word.id = 'w-' + phraseIndex + index + nanoid(4)
    })

    // [abc] [dsd] [sdf^dsf] [efefe] -> remove <dsf>
    const frontPercentage = this.removeCharsInWord(clone, wordIndex, charIndex, cloneWord.word.length)

    // remove [efefe]
    clone.words.splice(wordIndex + 1)

    // update phrase endTime
  //  clone.endTime = cloneWord && cloneWord.start <= cloneWord.end? (cloneWord.startTime + (cloneWord.endTime - cloneWord.startTime)*frontPercentage) : clone.endTime
    clone.endTime = cloneWord.startTime + (cloneWord.endTime - cloneWord.startTime)*frontPercentage
    clone.words[clone.words.length -1].endTime = clone.endTime

    // default time value
    // if(clone.words[clone.words.length -1].endTime === clone.words[clone.words.length -1].startTime){
    //   clone.words[clone.words.length -1].endTime = clone.words[clone.words.length -1].endTime + 0.4;
    //   clone.endTime = clone.endTime + 0.4;
    // }

    // Add space if the phrase is only 1 length
    // Hack fix revisit after test complete &#x200B;
    if (clone.words.length === 1 && clone.words[0].word === '') {
      clone.words[0].word = ' '
      clone.words[0].start = 0
      clone.words[0].end = 0
    }

    // remove Empty word, after splice to avoid index error
    this.removeEmptyWords(clone)

    // update phrase transcript text
    clone.transcript = this.toTranscript(clone.words)// phrase.words.map(word => word.word).join("")

    // newly created phrase
    // [abc] [dsd] [sdf^dsf] [efefe] -> remove <sdf>
    const endPercentage = this.removeCharsInWord(phrase, wordIndex, phraseWord.start, charIndex - phraseWord.start)

    // remove [abc] [dsd]
    phrase.words.splice(0, wordIndex)

    // update clone start
    //clone.startTime = cloneWord ? cloneWord.startTime : 0
   // phrase.startTime = phrase.words[0].startTime 
   
   // check if the first word is empty (got removed)
   const isAtEndOfPhrase = phrase.words.length === 1 && !phrase.words[0].word;
   let firstValidWord = !phrase.words[0].word && phrase.words.length > 1 ? phrase.words[1] :  phrase.words[0] 


   phrase.startTime =  endPercentage === 0 && !isAtEndOfPhrase? firstValidWord.startTime  : clone.endTime;
  // phrase.startTime = phrase.words[1] && endPercentage === 0 ? phrase.words[1].startTime  : clone.endTime;

    //phrase.startTime = endPercentage === 1 ? phrase.words[0].startTime : clone.endTime;
    phrase.words[0].startTime = phrase.startTime
    phrase.endTime = Math.max(phrase.endTime, phrase.startTime);
    phrase.words[phrase.words.length-1].endTime = Math.max(phrase.endTime, phrase.startTime);
    // phrase.startTime = phrase.words[1] && endPercentage === 0 ? phrase.words[1].startTime  : clone.endTime;
    // phrase.words[0].startTime = phrase.startTime;

      // default time value
    // if(phrase.words[phrase.words.length -1].endTime === phrase.words[phrase.words.length -1].startTime){
    //   phrase.words[phrase.words.length -1].endTime = phrase.words[phrase.words.length -1].endTime + 0.4;
    //   phrase.endTime = phrase.endTime + 0.4;
    // }

    // Add space if the phrase is only 1 length
    // Hack fix revisit after test complete &#x200B;
    if (phrase.words.length === 1 && phrase.words[0].word === '') {
      phrase.words[0].word = ' '
      phrase.words[0].start = 0
      phrase.words[0].end = 0
    }

    // update order
    if (previousPhrase) {
      clone.order = (clone.order + previousPhrase.order) / 2.0
    } else {
      clone.order = (clone.order + 0)/ 2.0
    }

    // remove Empty word after splice to avoid word index error
    this.removeEmptyWords(phrase)

    // update phrase transcript text
    phrase.transcript = this.toTranscript(phrase.words)// clone.words.map(word => word.word).join("")

    // Update the rest of the arrays word start end position
    this.updateWordStartEnd(phrase.words)

    // Update the current word position phraseWord
    phraseWord.end = phraseWord.end - phraseWord.start
    phraseWord.start = 0

    return clone
  },

  splitPhrase (phrase, charIndex, nextPhrase, phraseIndex) {
    let clone = JSON.parse(JSON.stringify(phrase))
   // clone.note = '';
    let wordIndex = this.getWordIndexByIndex(
      phrase.words,
      charIndex
    )

    if(!phrase.words[wordIndex]){
      const errorObjects = {};
      errorObjects.charIndex = charIndex || '';
      errorObjects.phraseWords = phrase.words || '';
      errorObjects.wordIndex = wordIndex || '';
      errorObjects.stack = 'transcriptHelper line 921';
      errorObjects.message = JSON.stringify(errorObjects);
      throw errorObjects;
    }

    let phraseWord = phrase.words[wordIndex]
    let cloneWord = clone.words[wordIndex]
    
    // create new id for the clone phrase
    clone.id = 'p-' + phraseIndex + nanoid(5)

    // create new id for all words in clone
    clone.words.forEach(function (word, index) {
      word.id = 'w-' + phraseIndex + index + nanoid(4)
    })

    // [abc] [dsd] [sdf^dsf] [efefe] -> remove <dsf>
    const frontPercentage = this.removeCharsInWord(phrase, wordIndex, charIndex, phraseWord.word.length)

    // remove [efefe]
    phrase.words.splice(wordIndex + 1)

    // update phrase endTime
    phrase.endTime = phraseWord && phraseWord.start <= phraseWord.end? (phraseWord.startTime + (phraseWord.endTime - phraseWord.startTime)*frontPercentage) : phrase.endTime
    phrase.words[phrase.words.length -1].endTime = phrase.endTime

    // Add space if the phrase is only 1 length
    // Hack fix revisit after test complete &#x200B;
    if (phrase.words.length === 1 && phrase.words[0].word === '') {
      phrase.words[0].word = ' '
      phrase.words[0].start = 0
      phrase.words[0].end = 0
    }

    // remove Empty word, after splice to avoid index error
    this.removeEmptyWords(phrase)

    // update phrase transcript text
    phrase.transcript = this.toTranscript(phrase.words)// phrase.words.map(word => word.word).join("")

    // newly created phrase
    // [abc] [dsd] [sdf^dsf] [efefe] -> remove <sdf>
    const endPercentage = this.removeCharsInWord(clone, wordIndex, cloneWord.start, charIndex - cloneWord.start)

    // remove [abc] [dsd]
    clone.words.splice(0, wordIndex)

    // update clone start
    let firstValidWord = !clone.words[0].word && clone.words.length > 1 ? clone.words[1] :  clone.words[0] 

    clone.startTime = (endPercentage === 0 ||endPercentage === 1) ? firstValidWord.startTime  : phrase.endTime;
    clone.words[0].startTime = clone.startTime;
    clone.endTime = Math.max(clone.endTime, clone.startTime);
    clone.words[clone.words.length-1].endTime = Math.max(clone.endTime, clone.startTime);

    // Add space if the phrase is only 1 length
    // Hack fix revisit after test complete &#x200B;
    if (clone.words.length === 1 && clone.words[0].word === '') {
      clone.words[0].word = ' '
      clone.words[0].start = 0
      clone.words[0].end = 0
    }

    // update order
    if (nextPhrase) {
      clone.order = (clone.order + nextPhrase.order) / 2.0
    } else {
      clone.order = clone.order + 1
    }

    // remove Empty word after splice to avoid word index error
    this.removeEmptyWords(clone)

    // update phrase transcript text
    clone.transcript = this.toTranscript(clone.words)// clone.words.map(word => word.word).join("")

    // Update the rest of the arrays word start end position
    this.updateWordStartEnd(clone.words)

    // Update the current word position
    cloneWord.end = cloneWord.end - cloneWord.start
    cloneWord.start = 0

    return clone
  },
  toTranscript (words) {
    return words.map(word => word.word).join('')
  },
  isUndoPressed(event){
    const keyCode = event.keyCode || event.which;
    return (event.metaKey || event.ctrlKey) && keyCode === 90;
  },
  isRedoPressed(event){
    const keyCode = event.keyCode || event.which;
    return (event.metaKey || event.ctrlKey) && event.shiftKey && keyCode === 90;
  },
  getMillis(time){
    return (time.seconds * 1000) + (time.nanoseconds / 1000000);
  },
  getLastModifiedPhrase(phrases){
    const me = this;
    let lastModified = null;
    let lastIndex = -1;
    let lastPhrase = null;
    phrases.forEach(function(phrase, index){
      if(phrase.modified && me.getMillis(phrase.modified) > lastModified){
       // if(phrase.modified && phrase.modified.toMillis() > lastModified){
        lastModified = me.getMillis(phrase.modified)//.toMillis();
        lastIndex =  index;
        lastPhrase = phrase;
      }
    });

    return {lastModifiedPhrase: lastPhrase, index: lastIndex};
  },
  updatePhraseTime(isStart, phrase, newSeconds){
    let removeIndex = [];
    let transcript = '';

    // if(isStart && newSeconds >= phrase.endTime){
    //   return;
    // }

    if(isStart){
      let startTime = newSeconds;

      // if(!phrase){
      //   console.log('no phrase')
      // }

      phrase.startTime = startTime;

        phrase.words.some(function(word, index){
          if(startTime >= word.endTime){
            removeIndex.push(index);
            transcript += word.word;
          }
          
          return startTime < word.endTime
        });

        if(removeIndex.length){
          phrase.words.splice(0,removeIndex.length);
        }

        phrase.words[0].word = transcript + phrase.words[0].word;
        phrase.words[0].startTime = startTime;

    }
    else{
      let endTime = newSeconds;
      let transcript = '';
      let removeIndex = -1;

      phrase.words.some(function(word,index){
        removeIndex = index;
        return endTime <= word.endTime;
      })

      for(var j = removeIndex; j < phrase.words.length; j++){
        transcript+=phrase.words[j].word;
      }

      phrase.endTime = endTime;
      phrase.words.splice(removeIndex + 1);
      phrase.words[phrase.words.length - 1].endTime = endTime; 
      phrase.words[phrase.words.length - 1].word = transcript;
    }

    this.updateWordStartEnd(phrase.words);
  },
  getInvalidTimePhrases(phrases){
    const me = this;
    var lastPhrase = {endTime: -1};
    const warningPhrases = [];
    const correctionPhrases = [];
    const hash = {};
    phrases.forEach(function(phrase, phraseIndex){
      if(!phrase.startTime && phrase.words && phrase.words[0] ){
        if(phraseIndex === 0){
          me.updateTime(phrase,phrase.words[0].startTime || 0, null );
        //  phrase.startTime = phrase.words[0].startTime || 0;
        }
        else{
          me.updateTime(phrase,(phrases[phraseIndex - 1].endTime + 0.01), null );
        //  phrase.startTime = (phrases[phraseIndex - 1].endTime + 0.01)
        }

        correctionPhrases.push(phrase);
      }
        // warningSection -1 is startTime, 1 is endTime, 2 is both
      if(phrase.endTime - phrase.startTime <= 0.1  && !hash[phrase.id]){
        phrase.warningType = 'short'
        phrase.warningSection = 2
        warningPhrases.push(phrase);
        hash[phrase.id] = phrase.warningSection;
      }
      else if(phrase.startTime <= lastPhrase.endTime && !hash[phrase.id]){
        phrase.warningType = 'overlap'
        phrase.warningSection = -1
        lastPhrase.warningType = 'overlap'
        lastPhrase.warningSection = 1
        warningPhrases.push(phrase);
        warningPhrases.push(lastPhrase);
        hash[phrase.id] = phrase.warningSection;
        hash[lastPhrase.id] = lastPhrase.warningSection;
      }
      

      lastPhrase = phrase;
    })

    return {warningPhrases,correctionPhrases};
  },
  getUpperAndLowerBound(duration, index, phrases){
    let lowerBound = 0;
    let upperBound = duration;

    if(phrases[index-1]){
      lowerBound = phrases[index-1].endTime
    }

    if(phrases[index+1]){
      upperBound = phrases[index+1].startTime
    }

    return {lowerBound, upperBound};
  },
  getRoundTo2Decimal(val){
    return textHelper.getRoundTo2Decimal(val);
    // if(typeof(val) === 'string'){
    //   return Number(Number(val).toFixed(2));
    // }
    // else if(typeof(val) === 'number'){
    //   return Number(val.toFixed(2));
    // }
    // else{
    //   return (val * 100)/100;
    // }
    // if(val < 0.005){
    //   return 0;
    // }

    // return this.toFixed(val,2);
    
  },
  scrollToTarget(selector){
    const me = this;
    let options = {
      container: "body",
      easing: "ease-in",
      offset: -370,
      lazy:false,
      force: false,
      cancelable: true,
      onStart: function(){ me.isScrolling = true;},
      onDone: function(){ me.isScrolling = false;},
      onCancel: function(){ me.isScrolling = false;},
      x: false,
      y: true
    };

    if(!phraseScroller){
      phraseScroller = scroller();
  }


  if(!me.isScrolling){
    me.scroll = phraseScroller(selector, 100, options);
  }

  },
}
